import { Alert } from "@/components/ui/Alert";
import styles from "@/pages/LoginPage/LoginPage.module.css";
import { LoginPageLogo } from "@/pages/LoginPage/LoginPageLogo";
import { LoginPageTitle } from "@/pages/LoginPage/LoginPageTitle";
import { MicrosoftLoginButton } from "@/pages/LoginPage/MicrosoftLoginButton";

type Props = {
    isErrorUserNotFound?: boolean;
};

const LoginPage = ({ isErrorUserNotFound }: Props) => {
    return (
        <div>
            <div className={styles.image} />
            <div className={styles.panel}>
                <div className={styles.panel_content}>
                    <LoginPageLogo />
                    <LoginPageTitle />
                    <div className={styles.login_method_list}>
                        {isErrorUserNotFound && (
                            <Alert severity="error">
                                We are sorry but you do not have an account in the LSSA, please{" "}
                                <b>contact your manager / cluster</b>.
                            </Alert>
                        )}
                        <MicrosoftLoginButton />
                    </div>
                </div>
            </div>
        </div>
    );
};

export { LoginPage };
